<template>
    <section>
        <titlebar :title-stack="titleStack">
           
        </titlebar>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
                <div class="tile is-ancestor">
                    <div class="tile is-parent is-vertical is-9">
                        <article class="tile is-child box">
                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider rules="required" name="código" v-slot="{ errors, valid }">
                                        <b-field :label="$t('ABREVIATURACADASTRO.CODIGO')"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                 :message="errors">
                                            <b-input type="text" v-model="model.id" maxlength="15" :has-counter="true" :readonly="$route.params.id"></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>                            
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider rules="required" name="nome" v-slot="{ errors, valid }">
                                        <b-field :label="$t('ABREVIATURACADASTRO.NOME')"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                 :message="errors">
                                            <b-input type="text" maxlength="500" v-model="model.nome" :has-counter="true"></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>                            
                            </div>
                        </article>
                    </div>

                    <div class="tile is-parent">
                        <article class="tile is-child">  
                            <article class="panel">
                                <div class="panel-heading">                                          
                                    <b-field>
                                        <b-switch v-model="model.desativado" type="is-danger">
                                            {{$t('ABREVIATURACADASTRO.DESATIVADO')}}
                                        </b-switch>
                                    </b-field>                             
                                </div>
                            </article>                                                         
                            
                        </article>
                    </div>
                </div>
                <nav class="level">
                    <div class="level-item">
                        <p class="buttons">
                            <b-button type="is-success"
                                      v-show="isInRole('mascaraAbreviatura-alterar')"
                                      :loading="salvandoDados"
                                      native-type="submit"
                                      icon-left="check-circle">
                                {{$t('ABREVIATURACADASTRO.SALVAR')}}
                            </b-button>
                            <b-button type="is-danger"
                                      native-type="button"
                                      icon-left="close-circle"
                                      @click="$router.back();">
                                {{$t('ABREVIATURACADASTRO.CANCELAR')}}
                            </b-button>
                        </p>
                    </div>
                </nav>
            </form>
        </ValidationObserver>
    </section>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import titlebar from '@/components/titlebar.vue'


    export default {
        data() {
            return {
                model: {
                    id: null,
                    nome: null
                },

                salvandoDados: false,
            };
        },
        components: {
            titlebar,            
        },
        created() {
            if (this.$route.params.id) {
                const id= btoa(this.$route.params.id)
                this.$http.get('/api/manutencao/mascaraAbreviatura?id=' + id)
                    .then(res => {
                        this.model = res.data;               
                        if(this.model.id == null){
                            this.$route.params.id = null;
                        } 
                    })

            }
        },
        computed: {
            titleStack() {
                return [
                    this.$t('ABREVIATURACADASTRO.MANUTENCAO'),
                    this.$t('ABREVIATURACADASTRO.ABREVIATURA'),
                    this.model.id ?? this.$t('SISTEMA.NOVO')
                ]
            },          
            ...mapState([
                'unidadeId',
                'config',
                'integradores'
            ]),
            ...mapGetters([
                'isInRole'
            ])
        },
        watch: {
          
        },
        methods: {
            onSubmit() {
                const newItem = Object.assign({}, this.model);          

                this.$http.post('/api/manutencao/mascaraAbreviatura', newItem)
                    .then(() => {
                        this.$router.push({ name: 'manutencao' })
                    })
                    .catch(err => {
                        console.error(err)
                        Object.keys(err.body.errors).forEach(x => {
                            this.$store.commit('ADD_ERRO', x + ": " + err.body.errors[x])
                        })
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: 'Erro ao salvar abreviatura: ' + err.body.title,
                            type: 'is-danger',
                            queue: false
                        })
                    })
            },
            addCodigo() {
                this.model.codigosIntegrador.push({
                    integradorId: null,
                    codigo: null
                });
            }          
        }
    }
</script>